import countryList from 'react-select-country-list'
import Select, { SelectProps } from '../Select'
import { useMemo } from 'react'

// omits 'options' from SelectProps since we're using countryList()
type CountrySelectProps = Omit<SelectProps, 'options'>

const CountrySelect: React.FC<CountrySelectProps> = (props) => {
    const options = useMemo(() => countryList().getData(), []);

    return (
        <Select
            {...props}
            options={options}
            placeholder={props.placeholder || 'Select an option'}
        />
    );
};

export default CountrySelect;
